import React from "react";
import { useTheme } from "styled-components";
import GenericNavigation from "components/GenericNavigation";
import PageBanner from "components/Marketing/PageBanner";
import PageTop from "components/Marketing/PageTop";
import ProviderMarketingPageMid from "components/Marketing/PageMid";
import TextAndButton from "components/TextAndButton";

export default function GiftCard() {
  const theme = useTheme();
  return (
    <GenericNavigation>
      <PageBanner
        altText="Macbook and iPhone devices"
        buttonLink="/provider/signup"
        buttonText="Register Now"
        callOutText={
          <>
            Meet GoodFriend:
            <br /> a tool to make everyday business easier
          </>
        }
        copy="With GoodFriend, you’ll reach new customers and simplify your pet care business operations. Scroll down to get your $100 gift card."
        image="/provider/giftcard/mac_devices.png"
        title="Hi, pet groomers and trainers,"
      />
      <PageTop
        sectionTitle="GoodFriend is designed for pet care pros like you!"
        blockOneTitle="Customer experience"
        blockOneDescription={
          <>
            We create an easy experience for
            <br />
            customers, new and old
          </>
        }
        blockTwoTitle="Promote your business"
        blockTwoDescription={
          <>
            We help you promote your
            <br />
            business to local pet parents
          </>
        }
        blockThreeTitle="Online booking"
        blockThreeDescription={
          <>
            We streamline your bookings,
            <br />
            intake forms, and payments
          </>
        }
        ctaBlockTitle={
          <>
            <div>Get $100 for being</div>
            <div>a GoodFriend</div>
          </>
        }
        ctaBlockDescription={
          <>
            We’ll email you a $100 gift card of your choice
            <br /> after you’ve registered and we’ve verified your business
          </>
        }
        ctaBlockDescriptionSecondary={
          <>
            Check your inbox, we will be in touch within
            <br />
            24 hours to verify your information.
          </>
        }
        buttonLink="/provider/signup"
        buttonText="Get Started"
      />
      <ProviderMarketingPageMid
        backgroundColor={theme.themeColors.blue3}
        outerWrapperMargin="0 0 -5.625rem"
        outerWrapperPadding="1rem 0 5.625rem"
        altText="dog with comb"
        imageFirst
        image="/provider/giftcard/dog_with_comb.png"
        callOutText="Now that you’re part of the GoodFriend community, you can start connecting with local pets and their parents right away."
        leadText="Here’s what we recommend:"
        bulletPoints={[
          {
            id: 0,
            text: "Add your business details, including services, and photos to your listing",
          },
          {
            id: 1,
            text: "Post your open appointments",
          },
          {
            id: 2,
            text: "Add employees’ availability, if appropriate",
          },
          {
            id: 3,
            text: "Verify your contact information so that pet parent messages go to the right inbox",
          },
          {
            id: 4,
            text: "Get ready to welcome new customers (we're launching to pet parents in February!)",
          },
        ]}
      />
      <TextAndButton
        buttonLink="https://airtable.com/shrqAcyN5SZcGQDPX"
        buttonText="Reach out to us"
        callOutText={
          <>
            Questions?
            <br />
            We have answers.
          </>
        }
        copy="Our support team is always ready to assist you and help getting started with GoodFriend. "
      />
    </GenericNavigation>
  );
}
